<template>
  <div id="app">
    <!-- 主页面容器 -->
    <div class="page">
      <!-- 头部导航 -->
      <Header />
      
      <!-- 路由视图内容 -->
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
      
      <!-- 页脚 -->
      <Footer />
    </div>
    
    <!-- 全局通知容器 -->
    <div class="snackbars" id="form-output-global"></div>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>

<style>
/* 页面切换过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}


</style>
